import { DateValue } from '@/components/ui/date-fields/types';

export function isValidHijriDate({ year, month, day }: DateValue): boolean {
    if (!year || !month || !day) return false;
    
    const y = parseInt(year);
    const m = parseInt(month);
    const d = parseInt(day);

    if (isNaN(y) || isNaN(m) || isNaN(d)) return false;
    
    // Basic range validation
    if (m < 1 || m > 12) return false;
    if (d < 1 || d > 30) return false; // Hijri months are max 30 days
    if (y < 1300 || y > 1500) return false; // Reasonable year range
    
    return true;
}

export function isValidGregorianDate({ year, month, day }: DateValue): boolean {
    if (!year || !month || !day) return false;
    
    const y = parseInt(year);
    const m = parseInt(month);
    const d = parseInt(day);

    if (isNaN(y) || isNaN(m) || isNaN(d)) return false;

    const date = new Date(y, m - 1, d);
    return date.getFullYear() === y && 
           date.getMonth() === m - 1 && 
           date.getDate() === d;
}